import { TextField } from "@material-ui/core"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"

const TextFieldClient = ({ clientSelected, props, timeout, placeholder, isEditable = false }) => {
    const [text, setText] = useState(props.value || "")
    const [firstClientSelected, setFirstClientSelected] = useState(true)
    const { field } = props.columnDef

    const handleText = event => {
        const data = event.target.value
        setText(data)
        setTimeout(() => props.onChange(data), timeout)
    }

    useEffect(() => {
        if (firstClientSelected) {
            setFirstClientSelected(false)
            return
        }
        
        let data = props.value || clientSelected[field] || ""
        data = clientSelected.clean ? "" : data
        setText(data)
        setTimeout(() => props.onChange(data), timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientSelected])

    return (
        <div>
            <TextField
                value={text}
                onChange={handleText}
                disabled={!isEditable && !!clientSelected[field]}
                placeholder={placeholder}
                InputProps={{
                    style: { fontSize: '13px' }
                }}
            />
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
})

const mapStateToProps = state => ({
    clientSelected: state.tasks.clientSelected
})

export default connect(mapStateToProps, mapDispatchToProps)(TextFieldClient)